<div>
	This will redirect you back to the boat game.
</div>